import React, { ReactElement } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import useStylesFormHelper from './form-helper.styles';

const FormHelper: ReactComponent = (props: ReactComponentProps): ReactElement | null => {
  const {
    isTouched,
    formError,
  } = props;

  const { classes } = useStylesFormHelper();

  if (!isTouched || !formError) {
    return null;
  }

  return (
    <FormHelperText
      classes={{
        root: classes.formHelper,
        error: classes.formHelperError,
      }}
    >
      {isTouched && formError}
    </FormHelperText>
  );
};

export default FormHelper;
